module.exports = __webpack_public_path__ + "static/mc-oranlar-3eba620bf0e67ead19d860bbfb9dd219.png";